import { httpUpdateImageSort } from '@/services/patient';
import React, { useEffect, useState } from 'react';

/**
 * @description: 图片排序hooks
 * @author: Claude
 * @version: v2.31.1
 * @Date: 2025-05-28 10:20:30
 */
interface ImageSortParams {
  patientId: string;
  fileType?: string;
  imagePaths?: string[];
}

interface ImageSortState {
  sortLoading: boolean;
  imageSortParams?: ImageSortParams;
  setImageSortParams: React.Dispatch<React.SetStateAction<ImageSortParams | undefined>>;
}

/**
 * 图片排序自定义Hook
 * @returns {ImageSortState} 包含loading状态和更新排序方法的对象
 */
const useImageSort = (): ImageSortState => {
  const [sortLoading, setSortLoading] = useState<boolean>(false);
  const [imageSortParams, setImageSortParams] = useState<ImageSortParams>();

  const httpUpdateImageSortReq = async () => {
    try {
      setSortLoading(true);
      const res = await httpUpdateImageSort(imageSortParams);
    } catch (error: any) {
      console.error('图片排序更新异常:', error);
    } finally {
      setSortLoading(false);
    }
  };

  useEffect(() => {
    imageSortParams && httpUpdateImageSortReq();
  }, [imageSortParams]);

  return {
    sortLoading,
    imageSortParams,
    setImageSortParams,
  };
};

export default useImageSort;
